<template>
  <div>
    <b-dropdown id="other-options" toggle-tag="div" toggle-class="p-0 bg-transparent" :disabled="isLoading">
      <template #button-content>
        <McButton
          variant="secondary"
          icon="icon-outline_chevron-down"
          icon-position="right"
          :text="$t('global.object.other')"
          :disabled="isLoading"
        />
      </template>

      <b-dropdown-item
        :disabled="isLoading"
        @click="actionHandlers.handleDuplicate"
      >
        {{ $t('global.duplicate') }}
      </b-dropdown-item>

      <b-dropdown-item
        v-if="status === 'STARTED'"
        :disabled="isLoading"
        @click="actionHandlers.handleChangeVehicleDriver"
      >
        {{ $t('fleetTaskInstant.action.changeVehicleOrDriver') }}
      </b-dropdown-item>

      <b-dropdown-item
        :disabled="isLoading"
        @click="actionHandlers.handleExportPdf"
      >
        {{ $t('fleetTaskInstant.action.printAssignmentDocument') }}
      </b-dropdown-item>

      <b-dropdown-item
        v-if="status !== 'CANCELED'"
        :disabled="isLoading"
        @click="actionHandlers.handleFleetTaskInstantHistory"
      >
        {{ $t('fleetTaskInstant.action.assignmentHistory') }}
      </b-dropdown-item>

      <!-- Delete Button (DRAFT & SCHEDULED status) -->
      <b-dropdown-item
        v-if="status !== 'STARTED'"
        class="red-text"
        :disabled="isLoading" 
        @click="actionHandlers.handleDelete"
      >
        {{ $t('global.delete') }}
      </b-dropdown-item>

      <!-- Cancel Button for 'STARTED' status -->
      <b-dropdown-item
        v-if="status === 'STARTED'"
        class="red-text"
        :disabled="isLoading" 
        @click="actionHandlers.handleCancel"
      >
        {{ $t('fleetTaskInstant.action.cancel') }}
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import McButton from '@/components/McButton'

export default {
  components: {
    McButton,
  },
  props: {
    status: {
      type: String,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    actionHandlers: {
      type: Object,
      default: () => ({}),
    }
  },
  computed: {
    ...mapState('fleetTaskInstant', [
      'listPointRes',
    ]),
  },
}
</script>
<style lang="scss" scoped>
:deep(.red-text) {
  a {
    color: $red;
  }
} 
</style>
